import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Thumb from '../../../Thumb';
import { formatPrice } from '../../../../services/util';
import { addItemToCart, manageFav, updateCartItem } from '../../../../services/carts/actions';
import { HiHeart, HiOutlineHeart } from 'react-icons/hi';
import { BsInfoCircle } from 'react-icons/bs';
import { OverlayTrigger, Tooltip, Button, ButtonGroup } from 'react-bootstrap';

const Product = ({ product, addItemToCart, manageFav, favorites, updateCartItem, bags, activeBag }) => {
  const p = Object.assign({}, product);
  let formattedPrice = formatPrice(p.price, p.currencyId);

  let productButton = (<Button variant="danger" size="lg" className="shelf-item__buy-btn" onClick={() => addItemToCart(Object.assign({}, p))}>Add to cart</Button>);

  
  if( activeBag !== null ){
    if( bags.length > 0 ){
      let isItemInBag = false;
      
      bags.forEach(bag => {
        if( bag.id === activeBag ){
          bag.items.forEach(item => {
            if( item.id === p.id ){
              isItemInBag = true;
            }
          })
        }
      })
      // console.log(activeBag, isItemInBag);
      
      if(isItemInBag === true)
      {
        let quantity = 0;
        bags.forEach(bag => {
          if( bag.id == activeBag ){
            bag.items.forEach(item => {
              if( item.id === p.id ){
                quantity = item.quantity;
              }
            });
          }
        });
        productButton = (<ButtonGroup aria-label="Basic example" size="lg">
          <Button variant="danger" type="button" onClick={() => updateCartItem(activeBag, p, "minus")} >-</Button>
          <Button variant="danger" disabled>{quantity}</Button>
          <Button variant="danger" type="button" onClick={() => updateCartItem(activeBag, p, "plus")}>+</Button>
        </ButtonGroup>)
      }
    }
  }

  return (
    <div
      className="shelf-item"
      data-sku={p.sku}
    >
      {p.isFreeShipping && (
        <div className="shelf-stopper">Free shipping</div>
      )}
      <Thumb
        classes="shelf-item__thumb"
        src={require(`../../../../static/products/${p.sku}_1.jpg`)}
        alt={p.title}
      />
      <div className='floating-icons'>
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={
            <Tooltip id={``}>
              {p.description}
            </Tooltip>
          }
        >
          <button type='button'>
            <BsInfoCircle />
          </button>
        </OverlayTrigger>
        <button type='button' onClick={() => manageFav(p)} style={{fontSize: "40px"}}>
          {
            favorites.map(item => item.id).includes(p.id) ? <HiHeart /> : <HiOutlineHeart />
          }
        </button>
      </div>
      <p className="shelf-item__title">{p.title}</p>
      <p className="shelf-item__brand">Brand: {p.brand}</p>
      <p className="shelf-item__weight">Item Weight: {p.itemWeight}</p>
      <div className="shelf-item__price">
        <div className="val">
          <small>{p.currencyFormat}</small>
          <b>{formattedPrice.substr(0, formattedPrice.length - 3)}</b>
          <span>{formattedPrice.substr(formattedPrice.length - 3, 3)}</span>
        </div>
      </div>
      {
        productButton
      }
    </div>
  );
};

Product.propTypes = {
  product: PropTypes.object.isRequired,
  addItemToCart: PropTypes.func.isRequired,
  manageFav: PropTypes.func.isRequired,
  updateCartItem: PropTypes.func.isRequired,
  bags: PropTypes.array,
  activeBag: PropTypes.number
};

const mapStateToProps = state => ({
  favorites: state.carts.favorites,
  bags: state.carts.bags,
  activeBag: state.carts.activeBag
});

export default connect(
  mapStateToProps,
  { addItemToCart, manageFav, updateCartItem }
)(Product);
